// extracted by mini-css-extract-plugin
module.exports = {"card":"styles-module--card--1UI2p","card__image":"styles-module--card__image--1UFm9","card__title":"styles-module--card__title--2p3n2"};